import React, { useState } from 'react';
import { withFeatureSafe } from 'Common/ErrorBoundaries';
import PropTypes from 'prop-types';
import { MdContentCopy } from 'react-icons/md';
import { toast } from 'react-toastify';
import { COPY_TEXT } from './ToastConstants';

const CopyToClipboard = (props) => {
    const [isCopied, setIsCopied] = useState(false);

    const writeTextInClipboardAsync = async () => {
        try {
            await navigator.clipboard.writeText(props.textToCopy);
            toast.success(COPY_TEXT);

        } catch (error) {
            setIsCopied(true);
        }
        setIsCopied(true)
        setTimeout(() => {
            setIsCopied(false);
        }, 2000);
    };

    return (
        <span
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                writeTextInClipboardAsync();
            }}
            title={ props.noTooltip ? "" : props.textToCopy}
            className={` relative  ${props.position === "right" ? " pr-6" : " pl-6"} cursor-pointer group`}
        >
            {props.children}
            <MdContentCopy className={`absolute top-0  ${props.position === "right" ? "-right-0" : "left-0"} hidden group-hover:inline ${isCopied ? 'text-primary' : ''}`} />
        </span>
    );
};

// Specifies the default values for props:
CopyToClipboard.defaultProps = {
    position: 'right',
};

CopyToClipboard.propTypes = {
    position: PropTypes.string,
};

export default withFeatureSafe(CopyToClipboard);